import {PropertyTypeConstructor} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ErrorOrEmpty, IValue} from '@mintdata/mint-kit/api/types/Value';
import {ABinaryData} from '@mintdata/mint-kit/api/values/ABinaryData';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AByte} from '@mintdata/mint-kit/api/values/AByte';
import {ACurrency} from '@mintdata/mint-kit/api/values/ACurrency';
import {ADate} from '@mintdata/mint-kit/api/values/ADate';
import {ADateTime} from '@mintdata/mint-kit/api/values/ADateTime';
import {AEmpty} from '@mintdata/mint-kit/api/values/AEmpty';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {AIntegerEnum} from '@mintdata/mint-kit/api/values/AIntegerEnum';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';
import {ATime} from '@mintdata/mint-kit/api/values/ATime';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {BaseCoercionUtil} from '@mintdata/mint-kit/impl/coercionUtils/BaseCoercionUtil';

export class ErrorCoercionUtil extends BaseCoercionUtil
{
    constructor()
    {
        super(Type.Error);
    }

    public toBoolean(from:AError):ABoolean | ErrorOrEmpty
    {
        return ABoolean.false();
    }

    public toByte(from:AError):AByte | ErrorOrEmpty
    {
        return AByte.fromNumber(0);
    }

    public toInteger(from:AError):AInteger | ErrorOrEmpty
    {
        return AInteger.fromNumber(0);
    }

    public toNumber(from:AError):ANumber | ErrorOrEmpty
    {
        return ANumber.fromNumber(0);
    }

    public toCurrency(from:AError):ACurrency | ErrorOrEmpty
    {
        return ACurrency.fromNumber(0);
    }

    public toString(from:AError):AString | ErrorOrEmpty
    {
        return new AString('');
    }

    public toDate(from:IValue):ADate | ErrorOrEmpty
    {
        return AEmpty.Value;
    }

    public toDateTime(from:IValue):ADateTime | ErrorOrEmpty
    {
        return AEmpty.Value;
    }

    public toTime(from:IValue):ATime | ErrorOrEmpty
    {
        return AEmpty.Value;
    }

    public toStringEnum(from:IValue, toCtor?:PropertyTypeConstructor<any>):AStringEnum | ErrorOrEmpty
    {
        return AEmpty.Value;
    }

    public toIntegerEnum(from:IValue, toCtor?:PropertyTypeConstructor<any>):AIntegerEnum | ErrorOrEmpty
    {
        return AEmpty.Value;
    }

    public toBinaryData(from:IValue):ABinaryData | ErrorOrEmpty
    {
        return AEmpty.Value;
    }

    public toFrame(from:IValue):IFrame | ErrorOrEmpty
    {
        return AEmpty.Value;
    }

    public toCustom(from:IValue, toCtor:PropertyTypeConstructor<any>):any | ErrorOrEmpty
    {
        return AEmpty.Value;
    }
}
